<template>
    <div>
        <div class="form-footer text-right" v-if="Images.length > 0">
            <div class="myCheckboxAll" style=" margin-bottom: 10px; float:left;margin-left: 10px; font-size: 16px">
                <input class="checkAll" @click="selectAll()" type="checkbox" v-model="checked"><span
                    class="checkAllBoxes"></span>Select All</div>
            <button type="button" class="btn btn-danger btn-sm ml-1 deleteMultiple" style="display: none;"
                @click="deleteMedia()">Delete Selected </button>
        </div>
        <div style="background-color: #e7eae1; display:inline-block;width: 100%;padding: 10px;" class="mainDiv"
            :data-show="Images">
            <div v-for="(image , index) in Images" :key="index" style="float: left">
                <img :src="image.s3_path" class="singleImage " />
                <p>{{image.file_name | subStr}}</p>
                <div class="mycheckBox">
                    <input class="mycheckboxForImage" name="imageSelect" type="checkbox" :value="image.id"
                        :data-imagesarrayindex="index" v-model="checked">
                    <span class="checkmark"></span>
                </div>
                <div class="imageActions" v-if="active">
                    <a data-fancybox="images" :data-caption="image.file_name" class="fancybox-thumb"
                        :href="image.s3_path" :data-page="image">
                        <font-awesome-icon icon="eye" class="icons" />View
                    </a><br /><br>
                    <a @click="copyUrl()" href="javascript:;"
                        :data-url="image.s3_path">
                        <font-awesome-icon icon="copy" class="icons" />Copy URL
                    </a><br /><br>
                    <a @click="deleteMedia(image.id,index)" href="javascript:;" :data-id="image.id">
                        <font-awesome-icon icon="trash" class="icons" />Delete
                    </a><br />
                </div>
            </div>
            <div class="message1"
                style="padding-top: 32px; display: none;float: left;height: 67px;width: 100%;text-align: center;">
                <h6> Scroll down to Load More Images......</h6>
            </div>
            <div style="text-align: center;padding-top: 20px;" v-if="Images.length <= 0">
                <h5>No media file found.</h5>
            </div>
            <input type="text" style="opacity: 0;" value="" id="imageUrl">
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    import axios from 'axios';
    export default {
        name: "image_table.vue",
        data: function () {
            return {
                active: 'false',
                limit: 18,
                start: 2,
                action: 'inactive',
                checked: [],
            };
        },
        props: [
            'Images', 'totalPages', 'page', 'totalImages',
        ],
        filters: {

            subStr: function (string) {
                return string.substring(0, 15) + '...';
            }

        },
        mounted: function () {
            var self = this;
            $.fancybox.defaults.btnTpl.cp = '<button data-fancybox-cp class="fancybox-button fancybox-button--cp"  title="Copy">' +
                '<svg viewBox="0 0 20 20">' +
                '<path d="M15.475,6.692l-4.084-4.083C11.32,2.538,11.223,2.5,11.125,2.5h-6c-0.413,0-0.75,0.337-0.75,0.75v13.5c0,0.412,0.337,0.75,0.75,0.75h9.75c0.412,0,0.75-0.338,0.75-0.75V6.94C15.609,6.839,15.554,6.771,15.475,6.692 M11.5,3.779l2.843,2.846H11.5V3.779z M14.875,16.75h-9.75V3.25h5.625V7c0,0.206,0.168,0.375,0.375,0.375h3.75V16.75z"/>' +
                '</svg>' +
                '</button>';

            $('body').on('click', '[data-fancybox-cp]', function () {
                var url = $('.fancybox-slide--current').find('.fancybox-image').attr('src');
                self.copyUrl(url);
            });
            $('body').on('click', ".mycheckboxForImage", function (e) {
                if ($('[name="imageSelect"]:checked').length > 0) {
                    $('.mycheckBox').show();
                    $('.imageActions').hide();
                    $('.deleteMultiple').show();

                    $('.saveBtn').attr("disabled", true);
                    $('.resetBtn').attr("disabled", true);
                }
                else {
                    $('.checkAll').prop('checked', false);
                    $('.mycheckBox').hide();
                    $('.deleteMultiple').hide();
                    $('.saveBtn').attr("disabled", false);
                    $('.resetBtn').attr("disabled", false);
                }
                if ($('[name="imageSelect"]:checked').length == self.Images.length) {
                    $('.checkAll').prop('checked', true);
                }
                else {
                    $('.checkAll').prop('checked', false);
                }
            });
            $('body').on('mouseover', '.singleImage', function (e) {
                if ($('[name="imageSelect"]:checked').length == 0) {
                    $('.imageActions').hide();
                    $('.mycheckBox').hide();

                    $(this).parent().children('.imageActions').show();
                    $(this).parent().children('.mycheckBox').show();
                }
                else {
                    $('.imageActions').hide();
                }
            });
            $('body').on('mouseleave', '.mainDiv', function (e) {
                if ($('[name="imageSelect"]:checked').length == 0) {
                    $('.imageActions').hide();
                    $('.mycheckBox').hide();
                }
            });
            $(window).scroll(function () {
                if (self.action != 'active') {
                    if (self.Images.length < self.totalImages) {
                        var action = 'inactive';
                        $('.message1').show();
                    }
                    else {
                        var action = 'active';
                        $('.message1').hide();
                    }
                }
                if ($(window).scrollTop() + $(window).height() == $(document).height() && action == 'inactive') {
                    var skipRecord = self.Images.length;
                    let loader = self.$loading.show({
                        loader: 'dots',
                        container: self.fullPage ? null : self.$refs.formContainer,
                    });

                    setTimeout(function () {
                        self.$store.dispatch('mediauploads/moreImages', [self.start, self.limit, skipRecord])
                            .then((response) => {
                                if (response.data.found < self.limit) {
                                    self.action = 'active';
                                    $('.message1').hide();

                                    setTimeout(() => loader.hide(), 1 * 300);
                                }
                                setTimeout(() => loader.hide(), 1 * 300);
                                self.start = self.start + 1;
                            });
                    }, 1000);
                }
            });
        },
        methods: {
            copyUrl(url) {
                if (url != undefined && url != '') {
                    var Url = url;
                    document.getElementById("imageUrl").value = Url;
                    var copyText = document.getElementById("imageUrl");
                    copyText.select();
                    try {
                        var successful = document.execCommand('copy');
                        var msg = successful ? 'successful' : 'unsuccessful';
                        this.$store.dispatch('message/update', {
                            title: '',
                            body: 'Your URL is copied successfully',
                            class: 'success',
                            confirm: false
                        }, { root: true });
                    } catch (err) {
                        this.$store.dispatch('message/update', {
                            title: 'Copied Image Url',
                            body: 'Oops, unable to copy',
                            class: 'warning',
                            confirm: false
                        }, { root: true });
                    }
                }
                else {
                    var Url = event.target.dataset.url;
                    document.getElementById("imageUrl").value = Url;
                    var copyText = document.getElementById("imageUrl");
                    copyText.select();
                    try {
                        var successful = document.execCommand('copy');
                        var msg = successful ? 'successful' : 'unsuccessful';
                        this.$store.dispatch('message/update', {
                            title: '',
                            body: 'Your URL is copied successfully',
                            class: 'success',
                            confirm: false
                        }, { root: true });
                    } catch (err) {
                        this.$store.dispatch('message/update', {
                            title: 'Copied Image Url',
                            body: 'Oops, unable to copy',
                            class: 'warning',
                            confirm: false
                        }, { root: true });
                    }
                }
            },
            selectAll() {
                $(".checkAll").change(function () {
                    $("input:checkbox").prop('checked', $(this).prop("checked"));
                });
                if ($("input:checkbox").prop('checked')) {
                    $('.mycheckBox').show();
                    $('.deleteMultiple').show();
                    $('.saveBtn').attr("disabled", true);
                    $('.resetBtn').attr("disabled", true);
                }
                else {
                    $('.mycheckBox').hide();
                    $('.deleteMultiple').hide();
                    $('.saveBtn').attr("disabled", false);
                    $('.resetBtn').attr("disabled", false);
                    $('.singleImage').css('transform', '0.5');
                }
            },
            deleteMedia(id, index) {
                var selectedImages = [];
                if (id != undefined && index != undefined) {
                    selectedImages.push({ index: index, id: id });
                }
                else {
                    $.each($("input[name='imageSelect']:checked"), function () {
                        selectedImages.push({ index: $(this).data('imagesarrayindex'), id: $(this).val() });
                    });
                }
                if (selectedImages.length <= 0) {
                    this.$toast.warning('Please select an Image first');
                }
                else {
                    this.$store.dispatch('message/update', {
                        title: '',
                        body: 'Are you sure you want to delete ?',
                        class: 'danger',
                        confirm: true
                    });
                }
                this.$bus.$off('proceed');
                this.$bus.$once('proceed', () => {
                    // code for deletig the image
                    this.delete(selectedImages);
                    this.$store.dispatch('message/close');
                });
            },
            delete(media) {
                $('.checkAll').prop('checked', false);
                this.$store.dispatch('mediauploads/deleteMedia', media)
                    .then((response) => {
                        // send successful message
                        this.$toast.success('Image Deleted successfully');
                        $('.mycheckBox').hide();
                        $('.saveBtn').attr("disabled", false);
                        $('.resetBtn').attr('disabled', false);
                    })
                    .catch(() => {
                        // send error message
                        this.$toast.error('Image can not be Deleted at this time');
                    });
            },
        }
    }
</script>

<style scoped>
    .singleImage {
        height: 154px;
        width: 154px;
        margin: 0px 10px 10px 10px;
        border: 2px solid #ccc;
        /* Gray border */
        border-radius: 4px;
        /* Rounded border */
        padding: 5px 5px 25px 5px;
        background-color: white;
    }

    .imageActions {
        height: 154px;
        width: 154px;
        color: #ffffff;
        padding: 25px 15px 10px 38px;
        position: relative;
        background-color: rgba(50, 52, 68, 0.58);
        margin-left: 10px;
        display: none;
        margin-top: -164px;
        margin-bottom: 10px;
        font-size: 12px;
    }

    .imageActions>a {
        color: #ffffff !important;
        text-decoration: none !important;
    }

    .icons {
        margin-right: 5px;
    }

    .singleImage:hover {
        box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
    }

    .mycheckboxForImage {
        margin-left: -22px;
        position: absolute;
        margin-top: -160px;
        z-index: 3;
        transform: scale(1.5)
    }

    .mycheckBox {
        display: none;
        position: relative;
        padding-left: 35px;
        cursor: pointer;
        font-size: 22px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .mycheckBox input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        margin-top: -164px;
        margin-left: 10px;
        z-index: 1;
        background-color: #ffffff;
        border: 1px solid rgba(50, 52, 68, 0.58);
        ;
    }

    .mycheckBox:hover input~.checkmark {
        background-color: #ccc;
    }

    .mycheckBox input:checked~.checkmark {
        background-color: #2196F3;
        padding: 10px;
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .mycheckBox input:checked~.checkmark:after {
        display: block;
    }

    .mycheckBox .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .checkAll {
        margin-left: -21px;
        margin-top: 4px;
        z-index: 3;
        transform: scale(1.5)
    }

    .myCheckboxAll {
        position: relative;
        padding-left: 35px;
        margin-top: 8px;
        cursor: pointer;
        font-size: 22px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .myCheckboxAll input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    /* Create a custom checkbox */
    .checkAllBoxes {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        margin-left: 10px;
        z-index: 1;
        background-color: #ffffff;
        border: 1px solid rgba(50, 52, 68, 0.58);
        ;
    }

    .myCheckboxAll:hover input~.checkAllBoxes {
        background-color: #ccc;
    }

    .myCheckboxAll input:checked~.checkAllBoxes {
        background-color: #2196F3;
        padding: 10px;
    }

    .checkAllBoxes:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .myCheckboxAll input:checked~.checkAllBoxes:after {
        display: block;
    }

    .myCheckboxAll .checkAllBoxes:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .deleteMultiple {
        margin-bottom: 10px;
    }

    .mainDiv p {
        text-align: center;
        margin-top: -32px;
        font-size: 11px;
        font-weight: 600;
        margin-left: 10px;
        margin-right: 10px;
    }

    #loader {
        position: absolute;
        left: 50%;
        /* top: 50%; */
        z-index: 1;
        margin: -75px 0 0 -75px;
        border: 16px solid #f3f3f3;
        border-radius: 50%;
        border-top: 16px solid #090a0a;
        width: 85px;
        height: 85px;
        -webkit-animation: spin 2s linear infinite;
        animation: spin 2s linear infinite;

    }
</style>